// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__64LLx","label":"styles_label__30lBG"};